import { useTranslation } from 'react-i18next';

interface Reason {
  icon: string;
  title: string;
  description: string;
}

export default function WhyChooseUs() {
  const { t } = useTranslation();
  const reasons = t('why.items', { returnObjects: true }) as Reason[];

  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold mb-4">
              <i className="ri-heart-line"></i>
              {t('why.badge')}
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {t('why.titleLine1')}<br />{t('why.titleLine2')}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              {t('why.subtitle')}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {reasons.map((reason) => (
                <div key={reason.title} className="flex gap-3 p-4 rounded-lg bg-background-50 border border-background-200/60">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 flex-shrink-0">
                    <i className={`${reason.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-sm text-foreground-900 mb-0.5">{reason.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20cleaning%20professional%20in%20bright%20modern%20living%20room%20with%20cleaning%20supplies%2C%20warm%20natural%20light%2C%20genuine%20smile%2C%20clean%20and%20tidy%20space%2C%20soft%20neutral%20tones%20with%20green%20accents%2C%20editorial%20portrait%20photography%2C%20fresh%20and%20inviting%20atmosphere%2C%20professional%20yet%20approachable%20look%2C%20beautiful%20composition%20with%20natural%20window%20light&width=800&height=1000&seq=limpia-whyus-01&orientation=portrait"
                alt={t('why.titleLine1') + ' ' + t('why.titleLine2')}
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-accent-500 text-background-50 rounded-xl px-5 py-4 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/20">
                <i className="ri-star-line text-xl"></i>
              </div>
              <div>
                <div className="text-lg font-bold leading-none">4.9/5</div>
                <div className="text-xs text-background-50/80">{t('why.rating')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}